import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Mail } from "lucide-react";
import { openCookiePreferences } from "@/components/CookieBanner";

export default function Footer() {
  return (
    <footer className="pt-14 pb-8" style={{ background: "#080808", borderTop: "1px solid var(--af-border-dark)" }}>
      <div className="af-container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo height={46} />
            <p className="text-white/60 text-sm mt-4 max-w-md leading-relaxed">
              Autofinanza es una plataforma tecnológica de intermediación. No otorga créditos ni garantiza su aprobación. Las condiciones, aprobación y contratación son determinadas exclusivamente por cada institución participante.
            </p>
            <div className="flex items-center gap-2 text-white/60 text-sm mt-4">
              <Mail size={16} className="text-af-orange-core" /> atencion@autofinanza.com.mx
            </div>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Legal</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link data-testid="footer-terminos" to="/legal/terminos" className="text-white/65 hover:text-af-orange-core">Términos y Condiciones</Link></li>
              <li><Link data-testid="footer-privacidad" to="/legal/privacidad" className="text-white/65 hover:text-af-orange-core">Aviso de Privacidad Integral</Link></li>
              <li><Link data-testid="footer-cookies" to="/legal/cookies" className="text-white/65 hover:text-af-orange-core">Política de Cookies</Link></li>
              <li><button data-testid="footer-cookie-prefs" onClick={openCookiePreferences} className="text-white/65 hover:text-af-orange-core">Preferencias de cookies</button></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Autofinanza</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link data-testid="footer-contacto" to="/contacto" className="text-white/65 hover:text-af-orange-core">Contacto</Link></li>
              <li><Link to="/proximamente" className="text-white/65 hover:text-af-orange-core">Ya tengo un trámite</Link></li>
              <li><Link to="/registro" className="text-white/65 hover:text-af-orange-core">Iniciar precalificación</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 text-center text-white/45 text-xs" style={{ borderTop: "1px solid var(--af-border-dark)" }}>
          AUTOFINANZA™ es una marca comercial. © 2026 Autofinanza, S.A. de C.V. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
